    <nz-collapse>
      <nz-collapse-panel nzHeader="Add Poll to Message" [nzActive]="false">
    <form [formGroup]="pollingForm" >

     <div nz-row [nzGutter]="4" style="margin-top: 2px; padding: 6px; border-radius: 4px;">
        <div nz-col nzSpan="16" >
          <nz-form-item>
            <nz-form-label nzRequired>Poll Question</nz-form-label>
            <nz-form-control nzErrorTip="Please enter a polling question">
              <input nz-input 
                     formControlName="pollingQuestion"
                     placeholder="Enter polling question"
                     />
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- <div nz-col nzSpan="9">
          <nz-form-item>
            <nz-form-label nzRequired>Polling Type</nz-form-label>
            <nz-form-control nzErrorTip="Please select polling option">
              <nz-select 
                formControlName="pollingType"
                style="width: 100%;">
                <nz-option nzValue="1" nzLabel="Single Choice Poll"></nz-option>
                <nz-option nzValue="2" nzLabel="Multiple Choice Poll"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div> -->
        <div nz-col nzSpan="8" style="display: flex; align-items: center; justify-content: end;">
          <button *ngIf="poll.pollId == 0" nz-button 
                  nzType="default" 
                  (click)="addNewPoll()" nz-tooltip="Add a new poll to the message">
            <span nz-icon nzType="plus"></span>Add Poll
          </button>
          <button *ngIf="poll.pollId > 0" nz-button 
                  nzType="default" 
                  (click)="removePoll()" nz-tooltip="Remove the poll from the message">
            <span nz-icon nzType="minus"></span>Remove Poll
          </button>
        </div>
        <div>
            <!--Display list of poll options already added-->
        </div>
        <div nz-row style="width: 100%" *ngFor="let option of poll.responseOptions">
          <div nz-col nzSpan="16">
            <nz-form-item>
                <div nz-row><nz-form-label nzSpan="8">Option {{option.value}}:</nz-form-label>
                <nz-form-control nzSpan="16" 
                                    [nzValidateStatus]="isOptionInvalid(option.pollResponseOptionId) ? 'error' : ''"
                                   [nzErrorTip]="isOptionInvalid(option.pollResponseOptionId) ? 'Please enter option text' : ''">
                    <input nz-input
                    #optionInput
                     [value]="option.optionText"
                     [class.error-highlight]="isOptionInvalid(option.pollResponseOptionId)"
                      (change)="$event.target && updateOptionText(option.pollResponseOptionId, $event)"
                      placeholder="Enter option text" />
                </nz-form-control>
                </div>
            </nz-form-item>
            </div>
            <div nz-col nzSpan="8" style="display: flex; justify-content: end;">
            <button nz-button 
                  nzType="default" 
                  (click)="deleteOption(option.pollResponseOptionId)">
            <span nz-icon nzType="minus"></span> Remove Option
          </button>
          </div>
        </div>
        <div nz-row style="width: 100%" *ngIf="poll.pollId > 0">
          <!-- <div nz-col nzSpan="16" >
            <nz-form-item>
                <div nz-row [nzJustify]="'space-between'">
                <nz-form-label nzSpan="8">New Option</nz-form-label>
                <nz-form-control nzSpan="16">
                    <input nz-input formControlName="newOption" placeholder="Enter new option" />
                </nz-form-control>
                </div>
            </nz-form-item>
          </div> -->
          <div nz-col nzSpan="24" style="display: flex; justify-content: center;">
            <button nz-button 
                  nzType="default" 
                  (click)="addNewOption()">
            <span nz-icon nzType="plus"></span> Add Option
          </button>
          </div>

        </div>
      </div>
</form> 
      </nz-collapse-panel>
    </nz-collapse>